import { getAppKey } from "../../shared/lib/helpers";
import { appSession } from "../../shared/lib/storage";
import { gatewayApiInstance } from "../axios/api-instances";
import type { RefreshTokenResponse, RefreshTokenVariables } from "../types";

const postStaffRefreshToken = (payload: RefreshTokenVariables) => {
  return gatewayApiInstance.post<RefreshTokenVariables, RefreshTokenResponse>(
    "/gateway/staff/refresh_token",
    {
      refresh_token: payload.refresh_token,
      shop_key: payload.shop_key,
      app_key: payload.app_key,
    },
    {
      headers: {
        Authorization: "",
      },
    }
  );
};

export const getStoreKeyFromPath = () => {
  const pathParts = location.pathname.split("/").filter(Boolean);

  if (pathParts.length >= 2 && pathParts[0] === "stores") {
    return pathParts[1];
  }
};

export const refreshAccessToken = async () => {
  const session = appSession.getItem();
  const storeKey = getStoreKeyFromPath();

  if (!session.refresh_token) {
    throw new Error("Refresh token is not available");
  }

  const response = await postStaffRefreshToken(
    !storeKey
      ? {
          refresh_token: session.refresh_token,
        }
      : {
          refresh_token: session.refresh_token,
          shop_key: storeKey,
          app_key: getAppKey(),
        }
  );

  appSession.setItem(response.data.result);

  return response;
};
